import { Packages } from '~shared/constants/pricing';

import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import { FeatureListMap } from '~app/pages/Pricing/transformers/summary/types';

import AdvantageFeatureList from './advantageFeatureList';
import PremierFeatureList from './premierFeatureList';
import EnterpriseFeatureList from './enterpriseFeatureList';
import FormsFeatureList from './formsFeatureList';
import FeatureRules from './featureRules';
/**
 * All feature list configuration mapping. See the FeatureListMap for how to set up the config object.
 * It is advisable to import experiment feature list config from the experiment subfolder of your experiment.
 * Failure to provide the correct config can result in incorrect UI and business logic presentation.
 * We also encourage all new package or package name change to define their own feature list.
 */
const Grow2792FeatureListMap: FeatureListMap = {
  [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment]: {
    [Packages.FormsAnnual]: {
      list: FormsFeatureList,
      rules: FeatureRules,
      includesDefaultList: true,
    },
    [Packages.FormsMonthly]: {
      list: FormsFeatureList,
      rules: FeatureRules,
      includesDefaultList: true,
    },
    [Packages.AdvantageAnnual]: {
      list: AdvantageFeatureList,
      rules: FeatureRules,
      includesDefaultList: true,
    },
    [Packages.AdvantageMonthly]: {
      list: AdvantageFeatureList,
      rules: FeatureRules,
      includesDefaultList: true,
    },
    [Packages.TeamAdvantage]: {
      list: AdvantageFeatureList,
      rules: FeatureRules,
      includesDefaultList: true,
    },
    [Packages.PremierAnnual]: {
      list: PremierFeatureList,
      rules: FeatureRules,
      includesDefaultList: true,
    },
    [Packages.TeamPremier]: {
      list: PremierFeatureList,
      rules: FeatureRules,
      includesDefaultList: true,
    },
    [Packages.Enterprise]: {
      list: EnterpriseFeatureList,
      rules: FeatureRules,
      includesDefaultList: true,
    },
  },
};

export default Grow2792FeatureListMap;
